export const SYNC_STATUS = {
  PENDING: "1",
  PROCESSING: "2",
  COMPLETED: "3",
  FAILED: "4",
  RETRYING: "5",
  CANCELLED: "6",
  EXPIRED: "7",
};

export const STATUS_GROUPS = {
  PROCESSING: `${SYNC_STATUS.PENDING},${SYNC_STATUS.PROCESSING},${SYNC_STATUS.RETRYING}`,
  COMPLETED: `${SYNC_STATUS.COMPLETED}`,
  FAILED: `${SYNC_STATUS.FAILED},${SYNC_STATUS.CANCELLED},${SYNC_STATUS.EXPIRED}`,
};

export const translations = {
  goBack: {
    id: "home.goBack",
    defaultMessage: "Go back to home",
  },
  title: {
    id: "vehicles.table.syncHistory",
    defaultMessage: "Sync & History",
  },
  subtitle: {
    id: "vehicle.single.registry.sync.history.subtitle",
    defaultMessage:
      "Track vehicle synchronization in other Edenred solutions. If there is a failure, try again via GoHub or the solution itself.",
  },
  searchPlaceholder: {
    id: "vehicle.single.registry.sync.history.searchPlaceholder",
    defaultMessage: "Search by plate",
  },
  clear: { id: "clear", defaultMessage: "Clear" },
  filterApply: {
    id: "home.filterApply",
    defaultMessage: "Apply",
  },
  filter: {
    id: "home.filter",
    defaultMessage: "Filter",
  },
  statusProcessing: {
    id: "vehicle.single.registry.sync.history.status.processing",
    defaultMessage: "Processing",
  },
  statusCompleted: {
    id: "vehicle.single.registry.sync.history.status.completed",
    defaultMessage: "Completed",
  },
  statusFailed: {
    id: "vehicle.single.registry.sync.history.status.failed",
    defaultMessage: "Failed",
  },
  platformOptionsFueling: {
    id: "vehicle.single.registry.sync.history.platform.fueling",
    defaultMessage: "Fueling",
  },
  platformOptionsMaintenance: {
    id: "vehicle.single.registry.sync.history.platform.maintenance",
    defaultMessage: "Maintenance",
  },
  operationCreate: {
    id: "vehicle.single.registry.sync.history.operation.create",
    defaultMessage: "Addition",
  },
  operationUpdate: {
    id: "vehicle.single.registry.sync.history.operation.update",
    defaultMessage: "Update",
  },
  operationDelete: {
    id: "vehicle.single.registry.sync.history.operation.delete",
    defaultMessage: "Deletion",
  },
  plate: { id: "plate", defaultMessage: "Plate" },
  user: { id: "user", defaultMessage: "User" },
  lastUpdate: {
    id: "vehicle.single.registry.sync.history.column.lastUpdate",
    defaultMessage: "Last Update",
  },
  dateTime: {
    id: "vehicle.single.registry.sync.history.dateTime",
    defaultMessage: "{date} at {time}",
  },
  operation: {
    id: "vehicle.single.registry.sync.history.column.operation",
    defaultMessage: "Operation",
  },
  clientCode: {
    id: "gohubInvoices.clientCode",
    defaultMessage: "Client Code",
  },
  platform: {
    id: "vehicle.single.registry.sync.history.column.platform",
    defaultMessage: "Platform",
  },
  status: { id: "status", defaultMessage: "Status" },
  message: {
    id: "vehicle.single.registry.sync.history.column.message",
    defaultMessage: "Message",
  },
};
